import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useMemo,
} from "react";
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Link,
} from "@mui/material";
import { MapContainer, TileLayer, useMap, useMapEvents } from "react-leaflet";
import ToolBarMaps from "../../../../../componentes/easyMaps/toolbarMapsPublicRp";
import L from "leaflet";
import "../../../../../componentes/leaflet-migrations";
import "../../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import "leaflet-routing-machine";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import TitleBar from "../../../../../componentes/easyMaps/titleBar";
import TitleBarPublic_ from "../../../../../componentes/easyMaps/titleBarPublic";
import mapRouteSegment from "../../../../../utils/easyMaps/mapRouteSegment";
import ContextMenu from "../../../../../componentes/easyMaps/contextMenu";
import AlertModal from "../../../../../componentes/alertModal";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import { useOutletContext, useParams } from "react-router-dom";

import PixiOverlay from "./pixiOverlayIcons";
import useTextures from "./hooks/useTextures";
import { PolylineCustom } from "../../geolocalizadoONUs/leaflatMapa/polyLine";
import RightBarEasyMapsOnus from "../../../../../componentes/easyMaps/rightBarEasyMapsOnus";
import { potenciaElemento } from "../../../../../utils/easyMaps/potenciaFtth";
import {
  Close,
  ContentCopy,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import RulerComponent from "../../../../../componentes/easyMaps/rulerPoints";
import { useMapa } from "../../../../../contexts/mapaContext";
import FilterCities from "../../../../../componentes/easyMaps/filterCities";

dayjs.extend(utc);
dayjs.extend(timezone);

interface OutletContextType {
  config: any;
}

interface LeafletMapProps {
  title?: string;
  setFullScreem: (value: boolean) => void;
  fullScreem: boolean;
  invalidElements?: any[];
  setElementSelected?: (el: any) => void;
  setElementONUSelected?: (el: any) => void;
  connectionSelected?: any;
  setConnectionSelected?: (conn: any) => void;
  elementSelected?: any;
  elementONUSelected?: any;
  iconsElements?: any[];
  mapId?: string;
  setSnackbar?: (snackbar: any) => void;
  editMode?: boolean;
  setEditMode?: (mode: boolean) => void;
  checkChanges?: boolean;
  setCheckChanges?: (value: boolean) => void;
  dataONUS?: any;
  boundsCoordinates?: [number, number][] | null;
  centerCoordinates?: [number, number];
  initialZoom?: string | number | null;
  isDateRecent?: boolean;
  collapse?: boolean;
  elements?: any[];
  connections?: any;
  produtos?: any;
  api?: any;
  mapas?: any[];
  setMapas?: (mapas: any[]) => void;
  setElements?: (elements: any[]) => void;
  setConnections?: (connections: any) => void;
  setIconsElement?: (icons: any[]) => void;
  element?: any;
  socketCliente?: any;
  staleHosts?: string[];
  isPublic?: boolean;
}

const TitleBarPublic = TitleBarPublic_ as any;

export interface LeafletMapRef {
  focusZoomExt: (id: string) => void;
}

const LeafletMapa = forwardRef<LeafletMapRef, LeafletMapProps>((props, ref) => {
  const {
    title,
    setFullScreem,
    fullScreem,
    invalidElements = [],
    setElementSelected = () => {},
    setElementONUSelected = () => {},
    connectionSelected,
    setConnectionSelected = () => {},
    elementSelected,
    elementONUSelected,
    iconsElements = [],
    mapId,
    setSnackbar,
    editMode,
    setEditMode,
    checkChanges,
    setCheckChanges,
    dataONUS,
    boundsCoordinates,
    centerCoordinates = [-10, -48],
    initialZoom,
    isDateRecent,
    collapse,
    staleHosts = [],
    isPublic = false,
  } = props;
  const { token } = useParams();

  const [lockMode, setLockMode] = useState(false);
  const [showLabel, setShowLabel] = useState(false);
  const [, setOpenRightBar] = useState(false);
  const [contextMenuFlow, setContextMenuFlow] = useState<any>(null);
  const [openAlertModal, setOpenAlertModal] = useState<any>(null);
  const [openConnection, setOpenConnection] = useState<string | null>(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  const [rulerMode, setRulerMode] = useState(false);
  const [rulerPoint, setRulerPoint] = useState<any[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(!isDateRecent);
  const [showStaleList, setShowStaleList] = useState(false);
  const [copiedStale, setCopiedStale] = useState(false);
  const [focusNodeId, setFocusNodeId] = useState<string | number | null>(null);
  const [citiesSwitchMakerVisible, setCitiesSwitchMakerVisible] = useState<
    any[]
  >([]);
  const mapRef = useRef<any>(null);
  const didSetInitialZoom = useRef(false);
  const shouldGetZoomRef = useRef(false);
  const {
    configurationMap,
    cities,
    citiesFilter,
    setCitiesFilter,
    allElementsMap,
    connections,
  } = useMapa() as any;
  const theme = useTheme();
  const { config } = useOutletContext<OutletContextType>();

  const [markers, setMarkers] = useState<any[]>([]);
  const [currentClusters, setCurrentClusters] = useState<any[]>([]);
  const [selectedCtoOnus, setSelectedCtoOnus] = useState<any[]>([]);

  const isSm = useMediaQuery(theme.breakpoints.down("lg"));

  const markersMap = useRef<Map<string, any>>(new Map());
  const ctoTitleMap = useRef<Map<string, any>>(new Map());
  const onusByCtoMap = useRef<Map<string, any[]>>(new Map());
  const serialToIdMap = useRef<Map<string, string>>(new Map());

  const onusInvalidas = useMemo(() => {
    return (invalidElements ?? []).filter((el) => el.tipoElemento === "onu");
  }, [invalidElements]);

  const updateReferenceMaps = useCallback((markersArray: any[]) => {
    const newMarkersMap = new Map<string, any>();
    const newCtoTitleMap = new Map<string, any>();
    const newOnusByCtoMap = new Map<string, any[]>();
    const newSerialToIdMap = new Map<string, string>();

    markersArray.forEach((marker) => {
      newMarkersMap.set(marker.id, marker);

      if (marker.tipoElemento === "onu") {
        const serial = (marker.id ?? "")
          .replace(/_onu$/i, "")
          .trim()
          .toUpperCase();
        newSerialToIdMap.set(serial, marker.id);
      }

      if (marker.tipoElemento === "cto") {
        const ctoTitle = (marker.titulo ?? "").trim().toUpperCase();
        newCtoTitleMap.set(ctoTitle, marker);

        if (marker.onus?.length) {
          newOnusByCtoMap.set(marker.id, marker.onus);
        }
      }
    });

    markersMap.current = newMarkersMap;
    ctoTitleMap.current = newCtoTitleMap;
    onusByCtoMap.current = newOnusByCtoMap;
    serialToIdMap.current = newSerialToIdMap;
  }, []);

  const filteredMarkers = useMemo(() => {
    let filtered = markers.filter((m) => m?.hasCto !== false);

    if (configurationMap?.configuracoes?.esconderOnu) {
      filtered = markers.filter(
        (m) =>
          m.tipoElemento === "cto" ||
          selectedCtoOnus.some((onu) => onu.id === m.id && onu.hasCto === true),
      );
    }

    if (configurationMap?.configuracoes?.showOnusWithoutCto) {
      filtered = filtered.concat(
        markers.filter((m) => m.tipoElemento === "onu" && m.hasCto === false),
      );
    }
    if (elementONUSelected || elementSelected) {
      filtered = filtered.concat(
        markers.filter(
          (m) =>
            m.id === elementONUSelected?.id || m.id === elementSelected?.id,
        ),
      );
    }

    setCitiesSwitchMakerVisible(
      [...new Set(filtered.map((m: any) => m.codeCity))].flat(),
    );

    if (citiesFilter.length > 0) {
      const cityCodes = new Set(citiesFilter.map((c: any) => c.codigo));
      filtered = filtered.filter((m: any) => {
        const arr = m.codeCity;
        if (!arr) return false;

        const citySet = new Set(arr);
        for (const code of cityCodes) {
          if (citySet.has(code)) return true;
        }
        return false;
      });
    }

    return filtered;
  }, [
    markers,
    configurationMap?.configuracoes?.esconderOnu,
    selectedCtoOnus,
    elementONUSelected,
    configurationMap?.configuracoes?.showOnusWithoutCto,
    citiesFilter,
  ]);

  useEffect(() => {
    setSnackbarOpen(!isDateRecent);
  }, [isDateRecent]);

  const ftthEscalaNum = useMemo(
    () =>
      (config?.configuracoes?.ftth?.camadaFTTH?.escala ?? [])
        .map((e: any) => parseFloat(e?.label))
        .filter(Number.isFinite)
        .sort((a: number, b: number) => a - b),
    [config?.configuracoes?.ftth?.camadaFTTH?.escala],
  );

  const bucketLabel = useCallback(
    (p: any) => {
      const rx = Number.parseFloat(p);
      if (!Number.isFinite(rx) || ftthEscalaNum.length === 0)
        return "Sem Dados";
      const topo = ftthEscalaNum[ftthEscalaNum.length - 1];
      if (rx > topo) return "Sem Dados";
      const idx = ftthEscalaNum.findIndex((c: number) => c >= rx);
      const ceil = idx >= 0 ? ftthEscalaNum[idx] : topo;
      return String(ceil);
    },
    [ftthEscalaNum],
  );

  const rangeCounts = useMemo(() => {
    const counts: Record<string, number> = {};
    for (const m of filteredMarkers) {
      const label = bucketLabel(potenciaElemento(m, config));
      counts[label] = (counts[label] ?? 0) + 1;
    }
    return counts;
  }, [
    filteredMarkers,
    bucketLabel,
    config?.configuracoes?.ftth?.analisePotencia,
  ]);

  useEffect(() => {
    const selected = new Set(
      (Array.isArray(configurationMap?.configuracoes?.camadaFTTH?.filtros)
        ? configurationMap?.configuracoes?.camadaFTTH?.filtros
        : []
      ).map((v: any) => String(v)),
    );

    const allElements = Array.from(
      (allElementsMap as Map<string, any>).values(),
    );

    const mks = allElements.map((element: any) => {
      const base = element.tipoElemento === "cto" ? ["cto"] : ["house"];

      const lat = parseFloat(element?.coordenadas?.lat);
      const lng = parseFloat(element?.coordenadas?.long);
      const position: [number, number] = [
        isNaN(lat) ? 0 : lat,
        isNaN(lng) ? 0 : lng,
      ];

      return {
        ...element,
        position,
        iconId: base,
        baseIcon: base,
        tint: element.color,
        label: element.titulo ?? element.id,
      };
    });

    const filteredMks = mks.filter((m: any) => {
      if (selected.size === 0) return true;
      const label = bucketLabel(potenciaElemento(m, config));
      return selected.has(label);
    });

    setMarkers(filteredMks);
    updateReferenceMaps(filteredMks);
  }, [
    configurationMap?.configuracoes?.camadaFTTH?.filtros,
    allElementsMap,
    updateReferenceMaps,
    bucketLabel,
    config?.configuracoes?.ftth?.analisePotencia,
  ]);

  const handleClick = useCallback(
    (id: string) => {
      if (rulerMode) return;
      const found = markersMap.current.get(id);
      if (!found) return;
      if (found.tipoElemento === "onu") {
        setElementONUSelected(found);

        const ctoTitle = (found.cto ?? "").trim().toUpperCase();
        const ctoMarker = ctoTitleMap.current.get(ctoTitle);

        if (ctoMarker) {
          setElementSelected(ctoMarker);
          const ctoOnusIds = onusByCtoMap.current.get(ctoMarker.id) || [];
          const ctoOnus = ctoOnusIds
            .map((onuId: string) => markersMap.current.get(onuId))
            .filter(Boolean);

          setSelectedCtoOnus([ctoMarker, ...ctoOnus]);
        } else {
          setSelectedCtoOnus([found]);
        }
      } else {
        setElementSelected(found);
        setElementONUSelected(null);
        const ctoOnusIds = onusByCtoMap.current.get(found.id) || [];
        const ctoOnus = ctoOnusIds
          .map((onuId: string) => markersMap.current.get(onuId))
          .filter(Boolean);
        setSelectedCtoOnus(ctoOnus);
      }
    },
    [rulerMode, setElementSelected, setElementONUSelected],
  );

  const handleBackgroundClick = useCallback(() => {
    setElementSelected(null);
    setElementONUSelected(null);
    setFocusNodeId(null);
    setSelectedCtoOnus([]);
  }, [setElementSelected, setElementONUSelected]);

  const handleClusterClick = useCallback(
    (cluster: any) => {
      if (!mapRef.current || rulerMode) return;
      const map = mapRef.current;
      const currentZoom = map.getZoom();
      const newZoom = Math.min(currentZoom + 2, 19);

      map.setView(L.latLng(cluster.center), newZoom);
    },
    [rulerMode],
  );

  const texturesReady = useTextures();

  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current && mapRef.current.invalidateSize) {
        mapRef.current.invalidateSize();
      }
    }, 300);
  }, [collapse]);

  useEffect(() => {
    if (!mapRef.current) return;
    SetMaxBounds();
    mapRef.current.invalidateSize();
  }, [mapRef.current]);

  useEffect(() => {
    if (!rulerMode) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "z") {
        e.preventDefault();
        removeLastEl();
      }
    };

    const handleMouseClick = (e: MouseEvent) => {
      if (e.button === 2) {
        e.preventDefault();
        removeLastEl();
      }
    };

    const handleContextMenu = (e: Event) => {
      if (rulerMode) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleMouseClick);
    window.addEventListener("contextmenu", handleContextMenu);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleMouseClick);
      window.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [rulerMode]);

  useEffect(() => {
    if (!elementSelected?.id) setElementSelected(null);

    if (editMode === false) {
      const currentMarker = markersMap.current.get(elementSelected?.id);
      if (currentMarker) {
        setElementSelected(currentMarker);
      }
    }

    if (editMode === false && elementSelected?.id) {
      const stillThere = markersMap.current.has(elementSelected.id);
      if (!stillThere) setElementSelected(null);
    }

    setConnectionSelected(null);
  }, [
    editMode,
    showLabel,
    markers,
    elementSelected?.id,
    setElementSelected,
    setConnectionSelected,
  ]);

  const getSerial = useCallback(
    (id: string) => (id ?? "").replace(/_onu$/i, "").trim().toUpperCase(),
    [],
  );

  const allOnus = useMemo(
    () => [...markers, ...onusInvalidas],
    [markers, onusInvalidas],
  );

  const serial = useMemo(
    () => (dataONUS?.serialOnu ?? "").trim().toUpperCase(),
    [dataONUS?.serialOnu],
  );

  const filteredOnus = useMemo(() => {
    if (!elementSelected?.id) return [];

    const element = markersMap.current.get(elementSelected.id);
    if (!element) return [];

    if (element.tipoElemento === "cto") {
      const onusIds = onusByCtoMap.current.get(element.id) || [];
      return onusIds
        .map((id: string) => allOnus.find((el) => el.id === id))
        .filter(Boolean);
    }

    const ctoTitle = (element.cto ?? "").trim().toUpperCase();
    const ctoMarker = ctoTitleMap.current.get(ctoTitle);

    return ctoMarker
      ? (onusByCtoMap.current.get(ctoMarker.id) || [])
          .map((id: string) => allOnus.find((el) => el.id === id))
          .filter(Boolean)
      : [element];
  }, [elementSelected, allOnus]);

  const mergedOnus = useMemo(() => {
    if (!serial || !dataONUS) return filteredOnus;

    const extra = formatExtraData(dataONUS) ?? {};

    return filteredOnus.map((onu: any) => {
      const matchOnu = getSerial(onu.id) === serial;
      if (!matchOnu) return onu;

      return {
        ...onu,
        data: {
          ...(onu.data ?? {}),
          ...extra,
        },
      };
    });
  }, [filteredOnus, serial, dataONUS, getSerial]);

  useEffect(() => {
    if (!elementSelected && !elementONUSelected) return;
    if (elementSelected && !elementSelected.coordinateIsValid) return;
    if (elementONUSelected && !elementONUSelected.coordinateIsValid) return;
    const cood = elementONUSelected?.position || elementSelected?.position;

    if (cood?.length) focusZoomCoordenates(cood[0], cood[1]);
  }, [elementSelected?.position, elementONUSelected?.position]);

  useEffect(() => {
    if (!elementSelected?.id) return;

    const found = serial
      ? mergedOnus.find((o: any) => getSerial(o.id) === serial)
      : mergedOnus.find((o: any) => o.id === elementSelected.id) || null;

    if (elementSelected.tipoElemento === "onu" && found) {
      setElementONUSelected(found);
    }
  }, [
    elementSelected?.id,
    mergedOnus,
    serial,
    getSerial,
    setElementONUSelected,
  ]);

  const SetMaxBounds = () => {
    if (!mapRef.current) return;

    const southWest = L.latLng(-89.98155760646617, -180);
    const northEast = L.latLng(89.99346179538875, 180);
    const bounds = L.latLngBounds(southWest, northEast);

    mapRef.current.setMaxBounds(bounds);
  };

  const clearRuler = () => {
    setRulerPoint([]);
    setRulerMode(false);
  };

  const removeLast = () => {
    setRulerPoint((prev) => {
      if (prev.length === 0) return prev;
      return prev.slice(0, -2);
    });
  };

  const removeLastEl = () => {
    setRulerPoint((prev) => {
      if (prev.length === 0) return prev;
      return prev.slice(0, -1);
    });
  };

  const styles = {
    paperContainer: {
      padding: "16px ",
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "100%",
      borderRadius: 3,
      mt: 5.5,
    },
    body: {
      width: "100%",
      height: "100%",
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      left: "0px",
      top: "0px",
      overflow: "hidden",
    },
    mapInfoStack: {
      padding: "12px 16px",
      width: "250px",
    },
    mapInfoDataStack: {
      padding: "12px 16px",
      width: "120px",
    },
    mapInfoTitle: {
      fontSize: "0.75rem",
      lineHeight: 1.25,
      fontWeight: 600,
      letterSpacing: "0.033em",
      color: "primary.main",
    },
    mapInfoText: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 400,
      textTransform: "capitalize",
    },
    fontPopup: {
      margin: "0px",
      fontSize: "10px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
      width: "100%",
      textAlign: "center",
      marginBottom: "10px",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
    },
  };

  function formatExtraData(obj: any) {
    return {
      statusContrato: { value: obj.statusContrato ?? "", unit: "" },
      pop: { value: obj.popCliente ?? "", unit: "" },
      desconexoes: { value: obj.desconexoesCliente ?? 0, unit: "x" },
      posicao: { value: obj.posicaoOnu ?? "", unit: "" },
      ip: { value: obj.ipCliente ?? "", unit: "" },
      plano: { value: obj.planoContrato ?? "", unit: "" },
      valorPlano: { value: obj.valorPlano ?? 0, unit: "Reais" },
      localizacao: {
        cep: obj.cepCliente ?? "",
        bairro: obj.bairroCliente ?? "",
        rua: obj.enderecoCliente ?? "",
        numero: obj.numeroEndereco ?? "",
      },
    };
  }

  const formatPoints = (edge: any) => {
    const nodeStart =
      markersMap.current.get(edge.referenceId) ||
      (edge.referenceId === elementSelected?.id ? elementSelected : null);
    const nodeEnd =
      markersMap.current.get(edge.destinationId) ||
      (edge.destinationId === elementSelected?.id ? elementSelected : null);

    const nodeStartPosition = {
      lat: parseFloat(nodeStart?.coordenadas?.lat) || 0,
      long: parseFloat(nodeStart?.coordenadas?.long) || 0,
      active: false,
    };

    const nodeEndPosition = {
      lat: parseFloat(nodeEnd?.coordenadas?.lat) || 0,
      long: parseFloat(nodeEnd?.coordenadas?.long) || 0,
      active: false,
    };

    return [
      nodeStartPosition,
      ...(edge.positionHandlers ?? []).map((a: any) => ({
        lat: a.y || 0,
        long: a.x || 0,
        active: false,
      })),
      nodeEndPosition,
    ];
  };

  function zoom(action: number) {
    if (!mapRef.current) return;
    const map = mapRef.current;
    let z = map.getZoom();
    if (z > 19 && action > 0) return;
    if (z < 1 && action < 0) return;
    map.setZoom(z + action);
  }

  function focusZoom(id: string) {
    if (!id) return;
    const element = markersMap.current.get(id);
    if (!element || !element.coordinateIsValid) return;

    const cood = element.position;
    if (cood.length) {
      focusZoomCoordenates(cood[0], cood[1]);
      setFocusNodeId(id);
    }
  }

  function focusZoomCoordenates(lat: number, lng: number) {
    const forceZoom = shouldGetZoomRef.current;

    if (isNaN(lat) || isNaN(lng)) return;
    const map = mapRef.current;
    if (!elementSelected)
      forceZoom ? map?.setView([lat, lng], 18) : map?.setView([lat, lng]);
    else
      forceZoom
        ? map?.setView([lat, parseFloat(String(lng)) + 0.0003], 18)
        : map?.setView([lat, parseFloat(String(lng)) + 0.0003]);
    shouldGetZoomRef.current = false;
  }

  useImperativeHandle(ref, () => ({
    focusZoomExt(id: string) {
      if (!id) return;

      handleClick(id);
      shouldGetZoomRef.current = true;
    },
  }));

  function Events() {
    const map = useMap();
    const moveTimeout = useRef<ReturnType<typeof setTimeout>>();

    useMapEvents({
      click(e) {
        if (rulerMode) {
          setRulerPoint((prev) => [...prev, e.latlng]);
        }
      },
      move() {
        if (moveTimeout.current) clearTimeout(moveTimeout.current);
        moveTimeout.current = setTimeout(() => {
          const center = map?.getBounds()?.getCenter();
          const z = map.getZoom();
          const url = new URL(window.location.href);
          url.searchParams.set("lat", String(center.lat));
          url.searchParams.set("lng", String(center.lng));
          url.searchParams.set("zoom", String(z));
          window.history.replaceState({}, "", url);
        }, 200);
      },
    });
    return null;
  }

  const SetInitialZoom = () => {
    const map = useMap();

    useEffect(() => {
      if (!map || didSetInitialZoom.current) return;

      if (initialZoom && centerCoordinates) {
        didSetInitialZoom.current = true;
        return;
      }

      if (Array.isArray(boundsCoordinates) && boundsCoordinates.length) {
        const dataBounds = L.latLngBounds(boundsCoordinates);
        map.fitBounds(dataBounds, {
          maxZoom: 14,
        });
        didSetInitialZoom.current = true;
      }
    }, [map]);

    return null;
  };

  const filteredConnections = useMemo(() => {
    if (!elementSelected?.id) return [];

    const filteredMarkerIds = new Set(filteredMarkers.map((m: any) => m.id));

    const expectedReferenceId =
      elementSelected.tipoElemento === "cto"
        ? elementSelected.id
        : `${elementSelected.cto?.replace(/\s/g, "")}_cto`;

    return Array.from((connections as Map<string, any>).values()).filter(
      (conn: any) => {
        const onu = markersMap.current.get(conn.destinationId);
        if (!onu) return false;

        if (!filteredMarkerIds.has(onu.id)) return false;

        const [lat, lng] = onu.position || [];
        if (!lat || !lng) return false;

        if (onu.hasCto === false) return false;

        return conn.referenceId === expectedReferenceId;
      },
    );
  }, [
    connections,
    filteredMarkers,
    elementSelected?.id,
    elementSelected?.tipoElemento,
    elementSelected?.cto,
  ]);

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1202 }}>
        {isPublic ? (
          <TitleBarPublic
            title={title}
            center={elementSelected != null || connectionSelected != null}
          />
        ) : (
          <TitleBar title={title} id={mapId} />
        )}
      </Box>
      <Box sx={styles.body}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          {snackbarOpen && (
            <Box
              sx={{
                position: "absolute",
                borderRadius: 2,
                width: "100%",
                py: 2,
                zIndex: 2,
                display: "flex",
                justifyContent: "center",
                gap: 1.5,
              }}
            >
              <Alert
                severity="warning"
                onClose={() => setSnackbarOpen(false)}
                action={
                  <Close
                    fontSize="small"
                    onClick={() => setSnackbarOpen(false)}
                    sx={{ cursor: "pointer" }}
                  />
                }
                sx={{
                  alignItems: "flex-start",
                  width: {
                    xs: "90%",
                    sm: "600px",
                  },
                }}
              >
                <Typography variant="body2">
                  Alguns elementos deste mapa estão{" "}
                  <strong>desatualizados</strong>.
                  <br />
                  Entre em contato com o{" "}
                  <Link
                    href="https://wa.me/5584994581475"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{
                      textDecoration: "none",
                      fontWeight: 500,
                      color: theme.palette.primary.main,
                    }}
                  >
                    suporte técnico
                  </Link>{" "}
                  para sincronizar as informações.
                </Typography>
                {staleHosts.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <Typography
                        variant="caption"
                        onClick={() => setShowStaleList((v) => !v)}
                        sx={{
                          cursor: "pointer",
                          fontWeight: 500,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.25,
                          userSelect: "none",
                        }}
                      >
                        {showStaleList ? (
                          <ExpandLess sx={{ fontSize: 14 }} />
                        ) : (
                          <ExpandMore sx={{ fontSize: 14 }} />
                        )}
                        {showStaleList ? "Ocultar" : "Ver"} lista (
                        {staleHosts.length})
                      </Typography>
                      <Tooltip
                        title={copiedStale ? "Copiado!" : "Copiar lista"}
                        placement="right"
                      >
                        <IconButton
                          size="small"
                          onClick={() => {
                            navigator.clipboard.writeText(
                              staleHosts.join("\n"),
                            );
                            setCopiedStale(true);
                            setTimeout(() => setCopiedStale(false), 2000);
                          }}
                          sx={{ p: 0.25 }}
                        >
                          <ContentCopy
                            sx={{
                              fontSize: 13,
                              color: copiedStale
                                ? "success.main"
                                : "text.secondary",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Collapse in={showStaleList}>
                      <Box
                        sx={{
                          mt: 0.5,
                          maxHeight: 120,
                          overflowY: "auto",
                          bgcolor: "action.hover",
                          borderRadius: 1,
                          px: 1.5,
                          py: 0.75,
                        }}
                      >
                        {staleHosts.map((host) => (
                          <Typography
                            key={host}
                            variant="caption"
                            display="block"
                            sx={{ lineHeight: 1.8, fontFamily: "monospace" }}
                          >
                            {host}
                          </Typography>
                        ))}
                      </Box>
                    </Collapse>
                  </Box>
                )}
              </Alert>
            </Box>
          )}

          <ToolBarMaps
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            setShowRuler={setRulerMode}
            setRulerPoint={setRulerPoint}
            showRuler={rulerMode}
            tipo={0}
            isFtth={true}
            config={config}
          >
            <ToolBarMaps.InputZoomGeo zoom={zoom} />
          </ToolBarMaps>

          <FilterCities
            data={cities}
            elementsFilter={citiesFilter}
            setElementsFilter={setCitiesFilter}
            citiesSwitchMakerVisible={citiesSwitchMakerVisible}
          />

          {!editMode && (
            <DescriptionBar
              key={"descrptionbar"}
              variant="ftth"
              elementSelected={!!elementSelected}
              rangeCounts={rangeCounts}
            />
          )}

          <MapContainer
            //fullscreenControl={false}
            ref={mapRef}
            key={`mapaSingle`}
            id="map"
            center={centerCoordinates}
            zoom={initialZoom ? Number(initialZoom) : 4}
            minZoom={3}
            zoomControl={false}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 0,
            }}
          >
            <TileLayer
              url={
                theme.palette.mode == "dark"
                  ? config?.configuracoes?.ftth?.mapaTile?.dark ||
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  : config?.configuracoes?.ftth?.mapaTile?.light ||
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              }
              maxZoom={19}
              detectRetina={true}
            />
            <Events />
            {rulerMode && (
              <RulerComponent
                rulerPoints={rulerPoint}
                removeLast={removeLast}
                onClearRuler={clearRuler}
              />
            )}
            <SetInitialZoom />

            {texturesReady && (
              <PixiOverlay
                key={"pixiFtth"}
                markers={filteredMarkers}
                enableClustering={mapRef?.current?.getZoom() <= 17}
                onClustersChange={setCurrentClusters}
                elementSelected={elementSelected}
                elementONUSelected={elementONUSelected}
                selectedCtoOnus={selectedCtoOnus}
                focusNodeId={focusNodeId}
                onClick={handleClick}
                onBackgroundClick={handleBackgroundClick}
                onClusterClick={handleClusterClick}
                //configLocal={configurationMap?.configuracoes?.ftth}
                showLabel={showLabel}
                rulerMode={rulerMode}
                configurationMap={configurationMap}
              />
            )}

            {elementSelected &&
              filteredConnections.map((conn: any, index: number) => {
                const position = formatPoints(conn);
                if (!editMode) {
                  const destination = markersMap.current.get(
                    conn.destinationId,
                  );
                  return (
                    <PolylineCustom
                      darkMode={theme.palette.mode == "dark"}
                      variant="ftth"
                      percent={potenciaElemento(destination, config)}
                      host={destination?.titulo}
                      data={{
                        ...conn?.data,
                        powerRx: destination?.data?.potencia?.rx,
                        powerTx: destination?.data?.potencia?.tx,
                        color: destination?.color,
                      }}
                      isDown={!!!destination?.data?.status?.value}
                      key={`${conn.id}-selected-${index}`}
                      positions={position.map((a: any) => [
                        a.lat || 0,
                        a.long || 0,
                      ])}
                      animation={"pontilhada"}
                      onClick={(e) => {
                        L.DomEvent.stopPropagation(e);
                        focusZoom(conn.destinationId);
                        setOpenConnection(conn.destinationId);
                      }}
                    />
                  );
                }
                return null;
              })}
          </MapContainer>

          <RightBarEasyMapsOnus
            mapId={mapId}
            setElementONUSelected={setElementONUSelected}
            elementONUSelected={elementONUSelected}
            setFocusNodeId={setFocusNodeId}
            focusZoom={focusZoom}
            setOpen={setOpenRightBar}
            setElement={() => {
              setElementONUSelected(null);
              setElementSelected(null);
              setSelectedCtoOnus([]);
            }}
            iconsElement={iconsElements}
            element={
              !editMode && elementONUSelected?.id
                ? elementONUSelected
                : elementSelected?.id
                  ? elementSelected
                  : null
            }
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/${isPublic ? "public/" : ""}${mapRouteSegment(
              elementSelected?.mapRef?.tipo,
            )}/${elementSelected?.mapRefId ?? ""}${isPublic ? `/${token}` : ""}`}
          />
        </Box>

        <ContextMenu
          contextMenu={contextMenuFlow}
          setContextMenu={setContextMenuFlow}
          editMode={editMode}
          setEditMode={setEditMode}
        />

        <AlertModal
          openModal={openAlertModal?.open ?? false}
          setOpenModal={(data: boolean) => setOpenAlertModal({ open: data })}
          buttonText={openAlertModal?.buttonText}
          buttonCancelText={openAlertModal?.buttonCancelText}
          confirmar={false}
          handleButton={() => {
            setCheckChanges?.(false);
            setOpenAlertModal({ open: false });
            if (openAlertModal.callback) {
              openAlertModal.callback(...(openAlertModal?.params || []));
              return;
            }
            setElementSelected(null);
            setElementONUSelected(null);
            setConnectionSelected(null);
          }}
          severity={openAlertModal?.severity}
          singleButton={false}
          textContent={openAlertModal?.text}
        />
      </Box>
    </>
  );
});

export default LeafletMapa;
